export default __webpack_public_path__ + "static/media/admin-dashboard-trucks.ceb46ba0.png";